module.exports = __webpack_public_path__ + "assets/media/lunch.fb03f729.mp3";